<template>
<section class="container content">
  <h1 class="title">404 - Page Not Found</h1>    
</section>
</template>

<script>

export default {
  name: 'NotFoundPage',
  metaInfo() { return {
    //the SPA answers 200 for unknown URLs, so say plainly this is not a page
    title: '404 Page Not Found',
    meta: [{ vmid: 'robots', name: 'robots', content: 'noindex' }],
  }},
}
</script>

<style scoped>
</style>



// WEBPACK FOOTER //
// src/components/NotFoundPage.vue